export const environment = {
  title: "Technomad Audio",
};
